import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection.tsx';
import type { ProviderData } from '@openx/types/provider.ts';
import { InfoIcon } from '@phosphor-icons/react/Info';
import { useTranslation } from 'react-i18next';
import { getProvidersLabels, providerFields } from '../../constants.ts';

type AllowedOrganizationsSectionProps = {
  allowedAccounts: ProviderData['allowed_accounts'];
};

export const AllowedOrganizationsSection = ({ allowedAccounts }: AllowedOrganizationsSectionProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const providersLabels = getProvidersLabels(t);

  return (
    <FormSection divider title={t('Allowed Organizations')}>
      {allowedAccounts.length === 0 ? (
        <Box sx={{ alignItems: 'center', display: 'flex' }}>
          <InfoIcon size={24} color={theme.palette.text.secondary} style={{ marginRight: theme.spacing(1) }} />
          <Typography data-test="no-linked-accounts-message">
            {t('No Organization(s) linked to this provider.')}
          </Typography>
        </Box>
      ) : (
        <>
          <Typography sx={{ color: 'text.secondary', mb: 1 }}>
            {providersLabels[providerFields.ALLOWED_ACCOUNTS]}
          </Typography>

          {allowedAccounts.map(({ account }, index) => (
            <Typography key={`${index}-${account.name}`} data-test="allowed-account-value">
              {account.name}
            </Typography>
          ))}
        </>
      )}
    </FormSection>
  );
};
